import type { ContentPack } from '../core/pack';
import { createRegistry } from '../core/pack';
import { VANILLA_PACK } from './vanilla';

/**
 * 全部已知数据包。
 *
 * 📌 **加扩展包时只改这里**：在 `src/packs/<名字>/` 建一个包，
 * 然后加进这个数组。核心逻辑、渲染层、网络层都不需要改动。
 */
export const ALL_PACKS: readonly ContentPack[] = [
  VANILLA_PACK,
  // 未来：IMPLODING_PACK, STREAKING_PACK, ...
];

/**
 * 默认注册表（只含原版包）。
 * 实际对局会用「房间启用的包」重新 `createRegistry`。
 */
export const defaultRegistry = createRegistry(ALL_PACKS);
